import useAuthorizationStore from './UseAuthorizationStore';
var useActivePermissionCache = function () { return useAuthorizationStore().activePermissionCache; };
export default useActivePermissionCache;
//# sourceMappingURL=UseActivePermissionCache.js.map